// extracted by mini-css-extract-plugin
module.exports = {"Actualites":"actualites_Actualites__JOXYo"};